import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { environment } from 'environments/environment';

const routes: Routes = [
  {
    path: '',
    data: {
      isFullHeader: true,
      breadcrumbKey: 'kz-breadcrumb.plan3d.landing',
      breadcrumbRedirect: '3d-home-design-software',
      metas: {
        titleKey: 'meta.landing.plan-3d.title',
        descriptionKey: 'meta.landing.plan-3d.description',
        image: `${environment.REDIRECT_URL}/assets/images/kazaplan/logiciel-plan-maison-3d.jpg`,
      },
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadChildren: () => import('./plan-3d/landing-plan-3d.module').then(m => m.LandingPlan3dModule),
      },
      {
        path: 'bathroom',
        loadChildren: () => import('./bathroom-3d/landing-plan-3d-bathroom-3d.module').then(m => m.LandingPlan3dBathroom3dModule),
      },
      {
        path: 'electrical-plan',
        loadChildren: () => import('./electricity/landing-plan-3d-electricity.module').then(m => m.LandingPlan3dElectricityModule),
      },
      {
        path: 'kitchen',
        loadChildren: () => import('./kitchen-planner/kitchen-planner.module').then(m => m.KitchenPlannerModule),
      },
      {
        path: 'design-by-a-professional',
        // loadChildren: () => import('./design-by-professional/design-by-professional.module').then(m => m.DesignByProfessionalModule)
        redirectTo: '/3d-home-design-software',
      },
      {
        path: '3d-landscaping-plan',
        loadChildren: () => import('./planner-3d-landscaping-plan/planner-3d-landscaping-plan.module').then(m => m.Planner3dLandscapingPlanModule)
      },
      /*{
        path: 'pricing',
        loadChildren: () => import('./pricing/pricing.module').then(m => m.PricingModule),
      },*/
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    LocalizeRouterModule.forChild(routes),
  ],
})
export class Plan3dModule {
}
